import { TuiNotificationService } from '@taiga-ui/core';
import { Directive, HostListener, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Directive({
  selector: '[copyToClipboard]',
  standalone: true,
})
export class CopyToClipboardDirective {
  private readonly alertService = inject(TuiNotificationService);
  private readonly translocoService = inject(TranslocoService);

  @Input('copyToClipboard') text: string | null | undefined = null;
  @Input() copySuccessMessage: string | null = null;

  @HostListener('click')
  copy(): void {
    if (!this.text) {
      return;
    }
    navigator.clipboard.writeText(this.text).then(() => {
      this.alertService
        .open(this.copySuccessMessage ?? this.translocoService.translate('Copié dans le presse-papiers'), {
          appearance: 'positive',
        })
        .subscribe();
    });
  }
}
